import script from "./grooming.vue?vue&type=script&lang=js&setup=true"
export * from "./grooming.vue?vue&type=script&lang=js&setup=true"

import "./grooming.vue?vue&type=style&index=0&id=9e7b45d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e7b45d8"]])

export default __exports__